import Navbar from "../components/navbar/navbar.component";
import BottomNav from "../components/bottomNav/bottomNav";

const LoggedIn = ({ children }) => {
  return (
    <div className={`h-[calc(100vh-72px)] w-full `}>
      <Navbar />
      <div className={`mt-[72px] p-8 h-full`}>{children}</div>
      <BottomNav />
    </div>
  );
};

export default LoggedIn;
